export const setCaretOnContentEditable = (element, placeAtStart) => {
  const range = document.createRange();
  const selection = window.getSelection();

  if (placeAtStart) {
    const textNode = document.createTextNode("");
    element.appendChild(textNode);
    range.setStart(element.childNodes[0], 0);
  } else {
    range.selectNodeContents(element);
  }

  range.collapse(placeAtStart);
  selection.removeAllRanges();
  selection.addRange(range);
  element.focus();
};
